// extracted by mini-css-extract-plugin
export default {"circle":"LK3dZ","animated":"awZHs","color":"pAxIT"};